export { default } from './AddCourseDialog';
